<template>
  <div>
    <div class="wz-page-header">
      <h1 class="wz-page-title">Motivos de cese</h1>
    </div>

    <wz-table-container>
      <wz-table-toolbar>
        <template #left>
          <div style="min-width: 220px">
            <wz-select
              :items="typeOptions"
              v-model="typeFilter"
              defaultOption="Todos los tipos"
            />
          </div>
        </template>

        <template #right>
          <wz-tooltip text="Recargar">
            <wz-button variant="outline" @click="loadData()">
              <i class="ri-loop-right-line"></i>
            </wz-button>
          </wz-tooltip>
          <wz-search-bar
            placeholder="Buscar por motivo"
            @input="search = $event"
            @search="search = $event"
          />
          <wz-button @click="$router.push({ name: 'cessation-reason-create' })">Agregar</wz-button>
        </template>
      </wz-table-toolbar>

      <wz-table>
        <thead>
          <tr>
            <th>Tipo de cese</th>
            <th>Cód. T-Registro</th>
            <th>Descripción abreviada</th>
            <th>Descripción completa</th>
            <th>Estado</th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="filteredList.length === 0">
            <td colspan="6" class="text-center text-muted py-4">No se encontraron resultados.</td>
          </tr>
          <tr v-for="o in filteredList" :key="o.id">
            <td>{{ typeLabel(o.terminationType) }}</td>
            <td>{{ o.tregistroCode || '-' }}</td>
            <td>{{ o.shortDescription || '-' }}</td>
            <td>{{ o.name }}</td>
            <td>
              <wz-badge :variant="o.status === 1 ? 'success-solid' : 'dark'" pill>
                {{ o.status === 1 ? 'ACTIVO' : 'INACTIVO' }}
              </wz-badge>
            </td>
            <td style="text-align: center;">
              <wz-dropdown
                :items="[
                  { key: 'edit',   label: 'Editar' },
                  { key: 'status', label: o.status === 1 ? 'Desactivar' : 'Activar' },
                ]"
                placement="left"
                @click="handleAction(o, $event)"
              />
            </td>
          </tr>
        </tbody>
      </wz-table>

      <wz-table-footer>
        <span>{{ filteredList.length }} registro(s)</span>
      </wz-table-footer>
    </wz-table-container>

    <wz-confirm-modal
      v-model="confirmModal.show"
      :title="confirmModal.title"
      :description="confirmModal.description"
      :accept-text="confirmModal.acceptText"
      :cancel-text="confirmModal.cancelText"
      @confirm="onModalConfirm"
      @cancel="closeConfirmModal"
    />
  </div>
</template>

<script>
import { Alert, ConfirmModalMixin } from '@wizepe/wizeui'
import { CessationReasonService } from '@/core/services'

export default {
  mixins: [ConfirmModalMixin],
  data() {
    return {
      list: [],
      search: '',
      typeFilter: null,
      typeOptions: [],
    }
  },
  computed: {
    filteredList() {
      let result = this.list
      if (this.typeFilter) result = result.filter(o => o.terminationType === this.typeFilter)
      if (this.search) {
        const q = this.search.toLowerCase()
        result = result.filter(o =>
          (o.name || '').toLowerCase().includes(q) ||
          (o.shortDescription || '').toLowerCase().includes(q))
      }
      return result
    },
  },
  methods: {
    typeLabel(key) {
      const f = this.typeOptions.find(t => t.key === key)
      return f ? f.label : key
    },
    async loadTypes() {
      try {
        this.typeOptions = (await CessationReasonService.listTypes()).payload || []
      } catch (e) {
        console.error(e)
      }
    },
    handleAction(o, item) {
      if (item.key === 'edit')   this.$router.push({ name: 'cessation-reason-edit', params: { id: o.id } })
      if (item.key === 'status') this.openChangeStatus(o)
    },
    async loadData() {
      try {
        await this.$store.dispatch('app/loading', true)
        this.list = (await CessationReasonService.list()).payload || []
      } catch (e) {
        console.error(e)
        Alert.error('Error al cargar los motivos de cese')
      } finally {
        await this.$store.dispatch('app/loading', false)
      }
    },
    openChangeStatus(o) {
      this.selectedOption = o
      this.openConfirmModal({
        title:       'Cambiar estado',
        description: '¿Está seguro que desea cambiar el estado de este motivo de cese?',
        acceptText:  'Aceptar',
        action:      'update',
      })
    },
    onModalConfirm() {
      this.closeConfirmModal()
      if (this.confirmModal.action === 'update') this.changeStatus()
    },
    async changeStatus() {
      try {
        await this.$store.dispatch('app/loading', true)
        const newStatus = this.selectedOption.status === 1 ? 0 : 1
        await CessationReasonService.changeStatus(this.selectedOption.id, newStatus)
        await this.loadData()
        Alert.success('Estado actualizado correctamente')
      } catch (ex) {
        console.error(ex)
        Alert.error(ex.errors ? ex.errors.message : 'Error al cambiar el estado')
      } finally {
        await this.$store.dispatch('app/loading', false)
      }
    },
  },
  async created() {
    await this.loadTypes()
    await this.loadData()
  },
}
</script>

<style lang="stylus"></style>
